import { writable, get } from 'svelte/store';
import { loadDocuments } from '../api/documents.api';
import { createUrlParamsString, updateUrlParam } from '../../../core/helpers/url.helper';
import { windowPushHistory } from '../../../core/helpers/window.helper';
export default class DocumentService {
    constructor(dataProvider) {
        this._dataProvider = dataProvider;
        this._pager = writable({ page: 1, perPage: 10 });
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        this._list = writable([]);
        this._total = writable(0);
        this._error = writable(false);
        this._processing = writable(false);
        this._active = writable(false);
        this._isFilterActive = writable(false);
        this.submitFromUrl();
    }
    submitSearch() {
        const params = {
            q: this._dataProvider.searchString,
            kategorie: this._dataProvider.kategorie,
            utvar: this._dataProvider.utvar,
            rok: this._dataProvider.rok,
            platnost: this._dataProvider.platnost,
        };
        windowPushHistory(createUrlParamsString(params));
        this.setPage(1);
        this._active.set(true);
        this.loadSearchResults();
    }
    goToPage(page) {
        windowPushHistory(updateUrlParam("strana", page));
        this.setPage(page);
        this.loadSearchResults();
    }
    changePageSize(pageSize) {
        windowPushHistory(updateUrlParam("pocet", pageSize));
        this.setPageSize(pageSize);
        this.goToPage(1);
    }
    submitFromUrl() {
        this._dataProvider.searchString = this._dataProvider.searchParameterFromUrl;
        this._dataProvider.kategorie = this._dataProvider.kategorieParameterFromUrl;
        this._dataProvider.utvar = this._dataProvider.utvarParameterFromUrl;
        this._dataProvider.rok = this._dataProvider.rokParameterFromUrl;
        this._dataProvider.platnost = this._dataProvider.platnostParameterFromUrl;
        const urlPage = this._dataProvider.pageParameterFromUrl;
        if (urlPage)
            this.setPage(urlPage);
        const urlPageSize = this._dataProvider.pageSizeParameterFromUrl;
        if (urlPageSize)
            this.setPageSize(urlPageSize);
        this._active.set(true);
        this.loadSearchResults();
    }
    loadSearchResults() {
        this._processing.set(true);
        const filterParams = {
            isWo: this.dataProvider.isWo(),
            order: this.dataProvider.getCategorySortBy(),
            query: this.dataProvider.searchString,
            categoryId: this.dataProvider.getCategoryAttributeBySlug(this.dataProvider.kategorie, 'id') || '',
            categorySlug: this.dataProvider.kategorie,
            documentFolderId: undefined,
            unitSlug: undefined,
            groupId: this.dataProvider.groupId,
            fileEntryTypeId: this.dataProvider.fileEntryTypeId,
            year: undefined,
            valid: undefined,
            showSiteUrl: this.dataProvider.showSiteUrl,
            pager: this.pager,
        };
        if (this.dataProvider.isWo()) {
            filterParams.year = this.transformAll(this.dataProvider.rok);
            filterParams.valid = this.transformAll(this.dataProvider.platnost);
        }
        else if (this.dataProvider.isWo() === false) {
            filterParams.documentFolderId = this.dataProvider.getFolderAttributeBySlug(this.dataProvider.utvar, 'id');
            filterParams.unitSlug = this.transformAll(this.dataProvider.utvar);
        }
        loadDocuments(filterParams)
            .then((response) => {
            // @ts-ignore
            // @ToDo What is the fuck?
            if (response === '') {
                throw 'BAD RESPONSE - EMPTY STRING';
            }
            this._list.set(response.results);
            this._pager.set(Object.assign(Object.assign({}, this.pager), { total: response.total }));
            this._total.set(response.total);
            this._error.set(false);
            this._isFilterActive.set(!!(filterParams.categorySlug || filterParams.query));
            // @ts-ignore
            setTimeout(() => removeClickFocus(), 100);
        })
            .catch(() => this._error.set(true))
            .finally(() => this._processing.set(false));
    }
    setPage(page) {
        this._pager.set(Object.assign(Object.assign({}, this.pager), { page }));
    }
    setPageSize(perPage) {
        this._pager.set(Object.assign(Object.assign({}, this.pager), { perPage }));
    }
    transformAll(value) {
        return (value === 'vse') ? '' : value;
    }
    get dataProvider() {
        return this._dataProvider;
    }
    get listSubs() {
        return this._list;
    }
    get activeSubs() {
        return this._active;
    }
    get isFilterActiveSubs() {
        return this._isFilterActive;
    }
    get totalSubs() {
        return this._total;
    }
    get errorSubs() {
        return this._error;
    }
    get processingSubs() {
        return this._processing;
    }
    get pagerSubs() {
        return this._pager;
    }
    get pager() {
        return get(this._pager);
    }
}
